export const getAssignedUnitsWithExpiringLeases = (state: any) => {
  const localState = state.manageLeaseExpirations;
  if (!localState || !localState.assignedUnits) return [];
  return localState.assignedUnits;
};
